import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { RenderSecure } from "../../util/script/RenderSecure";
import { sideMenuData } from "./SideMenuData";

const Sidebar = () => {
  const location = useLocation();
  const [activeMenu, setActiveMenu] = useState(null);
  const [activeSubMenu, setActiveSubMenu] = useState({
    menuId: null,
    subIndex: null,
  });

  // Keep active states in sync with current URL
  useEffect(() => {
    Object.keys(sideMenuData).forEach((menuIdStr) => {
      const menuId = parseInt(menuIdStr, 10);
      const menu = sideMenuData[menuId];

      // Check top-level menu
      if (menu.link === location.pathname) {
        setActiveMenu(menuId);
        setActiveSubMenu({ menuId: null, subIndex: null });
      }

      // Check submenu
      if (menu.subMenu) {
        menu.subMenu.forEach((subItem, subIndex) => {
          if (subItem.link === location.pathname) {
            setActiveMenu(menuId);
            setActiveSubMenu({ menuId, subIndex });
          }
        });
      }
    });
  }, [location.pathname]);

  const handleMenuClick = (menuId) => {
    // Toggle menu open/close on click
    setActiveMenu((prev) => (prev === menuId ? null : menuId));
  };

  return (
    <div className="sticky">
      <div
        className="main-menu main-sidebar main-sidebar-sticky side-menu"
        style={{ height: "100vh", overflowY: "auto", marginBottom: "30px" }}
      >
        <div className="main-sidebar-header main-container-1 active">
          <div
            className="sidemenu-logo"
            style={{ borderBottomRightRadius: "18px" }}
          >
            <a
              className="main-logo"
              href="/"
              style={{ borderBottomRightRadius: "25px" }}
            >
              <img
                src={
                  process.env.PUBLIC_URL + "/assets/img/brand/logo-light.png"
                }
                className="header-brand-img desktop-logo"
                alt="logo"
                style={{ height: "40px", width: "300px" }}
              />
            </a>
          </div>
          <div className="main-sidebar-body main-body-1">
            <div className="slide-left disabled" id="slide-left">
              <i className="fe fe-chevron-left" />
            </div>
            <ul className="menu-nav nav">
              {Object.keys(sideMenuData).map((menuIdStr) => {
                const menuId = parseInt(menuIdStr, 10);
                const menu = sideMenuData[menuId];

                return (
                  <RenderSecure code={menu.AccessCode} key={menuId}>
                    <li
                      className={`nav-item ${
                        activeMenu === menuId ? "active show" : ""
                      }`}
                    >
                      <Link
                        to={menu.link}
                        className="nav-link with-sub"
                        onClick={() => handleMenuClick(menuId)}
                      >
                        <span className="shape1" />
                        <span className="shape2" />
                        <i
                          className={menu.icon}
                          style={{
                            background:
                              "linear-gradient(135deg, #37a2d4, #076cca, #345546)",
                            WebkitBackgroundClip: "text",
                            WebkitTextFillColor: "transparent",
                            fontSize: "20px",
                          }}
                          aria-label={menu.name}
                        />
                        <span className="sidemenu-label">{menu.name}</span>
                        {menu.subMenu && (
                          <i
                            className={`angle fe fe-chevron-${
                              activeMenu === menuId ? "down" : "right"
                            }`}
                            style={{
                              background:
                                "linear-gradient(-180deg,#d437a0,rgb(221, 96, 121))",
                              WebkitBackgroundClip: "text",
                              WebkitTextFillColor: "transparent",
                              fontSize: "20px",
                            }}
                          />
                        )}
                      </Link>

                      {/* Submenu */}
                      {menu.subMenu && (
                        <ul
                          className={`nav-sub ${
                            activeMenu === menuId ? "open" : ""
                          }`}
                        >
                          {menu.subMenu.map((subItem, subIndex) => (
                            <RenderSecure
                              code={subItem.AccessCode}
                              key={`${menuId}-${subIndex}`}
                            >
                              <li className="nav-sub-item">
                                <Link
                                  className={`nav-sub-link ${
                                    activeSubMenu.menuId === menuId &&
                                    activeSubMenu.subIndex === subIndex
                                      ? "active show"
                                      : ""
                                  }`}
                                  to={subItem.link}
                                >
                                  <i className={subItem.icon}></i>
                                  {subItem.name}
                                </Link>
                              </li>
                            </RenderSecure>
                          ))}
                        </ul>
                      )}
                    </li>
                  </RenderSecure>
                );
              })}
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Sidebar;
